import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./Requirement.module.css";
import { customTextColor } from "../../utils/const";
import { useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { HiOutlineMailOpen } from "react-icons/hi";
import { IoIosSearch } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiLinkedinLogoLight } from "react-icons/pi";
//   import SideIcon from "./SideIcon";
import { BsThreeDotsVertical } from "react-icons/bs";
import Search from "../../assets/images/search (2).png";
import { BsFileEarmarkText } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import profile_image from "../../assets/images/ajit_image.jpeg";
import JobPost from "./JobPost";
import { PiFileTextLight } from "react-icons/pi";
import { PiFilesLight } from "react-icons/pi";
const MoreViewDetails = () => {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [oppen, setOppen] = useState(false);
  const [side, setSide] = useState(false);

  const handleCloseSide = () => setSide(false);
  const handleSide = () => setSide(true);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isProfileVisible, setIsProfileVisible] = useState(false);

  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const [typeResult, setTypeResult] = useState("public");
  const navigate = useNavigate();
  return (
    // <RootComponents>
    <>
      <Box className={styles.search_candidate_stucture}>
        <Box className={styles.track_submissions_heading}>
          <Box>
            <Typography>
              Job ID: <b>SEC00127</b>
            </Typography>
            <Typography>
              Post Categories: <b>High Importance</b>
            </Typography>
          </Box>
          <span>
            <Typography>
              Date: <b>12 May 2024, 12:50 PM</b>
            </Typography>
          </span>
        </Box>

        <Box className={styles.profile_and_submit}>
          <Box>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                <Typography sx={{ marginTop: "10px !important" }}>
                  <b>
                    Job Post: Looking for 10 Senior Network Engineer at
                    California, Taxes{" "}
                  </b>
                </Typography>
                <Typography sx={{ marginTop: "10px" }}>
                  <b>
                    {" "}
                    Senior Network Engineer, Exp 12 Years California, Taxes{" "}
                  </b>
                </Typography>
                <Typography>
                  <b>Full Time, W2, Contract, GC, USC </b>
                </Typography>
                <Typography>
                  <b> Onsite, Phone, In Person </b>
                </Typography>
                <Typography>
                  <b>$70k Yearly</b>
                </Typography>
                <Typography>
                  <b>Not disclosed </b>
                </Typography>
              </span>

              <span
                className={styles.phase2}
                style={{ marginTop: "20px !important", alignSelf: "start" }}
              >
                <Typography
                  sx={{
                    fontSize: "40px !important",
                    fontWeight: "600",
                    marginBottom: "0 !important",
                  }}
                >
                  10
                </Typography>
                <Typography>Job Openings</Typography>
              </span>
            </span>
          </Box>
        </Box>

        {/* <Box className={styles.candidate_text} sx={{ marginBottom: "14px" }}>
          {" "}
          <span>
            <Typography sx={{ color: "customTextColor" }}>
              <b>Job Description</b>
            </Typography>
            <Typography>
              SAFe Project Manager & Scrum Master with extensive experience in
              Scaled Agile Framework (SAFe) to manage and oversee complex
              projects within our Agile release Trains. Candidate should have
              stron background in IT project management coupled with deep
              knowledge of the Scaled Agile Framework( SAFe). This position
              requires a unique blend of technical project management expertise,
              agile methodologies, and a deep understanding of employee needs.
              We believe that empowered and engaged employees drive innovation
              and success. Our team is passionate about creating intuitive,
              user-friendly solutions that streamline workflows, foster
              collaboration, and enhance productivity
            </Typography>
            <Typography sx={{ color: "customTextColor" }}>
              <b>Mandatory Skills</b>
            </Typography>
            <Typography>
              Certifications: Project Management Professional (PMP), Certified
              Scrum Master (CSM), or similar certifications. SAFe Agilist (SA)
              or SAFe practitioner certification
              <div>
                Technical Background: Experience with software development or IT
                infrastructure
              </div>
            </Typography>
          </span>
        </Box> */}
        <Box className={styles.candidate_text} sx={{ marginBottom: "14px" }}>
          <span>
            {/* <Typography sx={{ color: "customTextColor" }}>
              <b>Job Description</b>
            </Typography> */}
            <Typography>
              Experience in developing data pipelines using Python, PySpark,
              Spark DataFrame, Spark SQL to Extract, Transform and Load data
              from various source/target systems like HDFS, AWS S3, Relational
              Databases like Oracle, SQL Server.
            </Typography>

            <ul>
              <li>
                Hands on working experience in requirement gathering, reporting,
                documentation, process mapping, scheduling, planning, and data
                analysis.
              </li>
              <li>
                Extensive experience building visualizations using Tableau,
                Quicksight and Looker.
              </li>

              <li>
                Strong analytical and problem-solving skills with experience in
                providing dynamic and data-driven solutions.
              </li>
              <li>
                Extensive experience in building and maintaining Big Data,
                Business Intelligence and data warehouse products and services.
              </li>
              <li>
                Hands on working experience in requirement gathering, reporting,
                documentation, process mapping, scheduling, planning, and data
                analysis.
              </li>
              <li>
                Extensive experience building visualizations using Tableau,
                Quicksight and Looker.
              </li>
              <li>
                Strong analytical and problem-solving skills with experience in
                providing dynamic and data-driven solutions.
              </li>
              <li>
                Extensive experience in building and maintaining Big Data,
                Business Intelligence and data warehouse products and services.
              </li>

              <hr></hr>

              <li>
                Hands on working experience in requirement gathering, reporting,
                documentation, process mapping, scheduling, planning, and data
                analysis.
              </li>
              <li>
                Extensive experience building visualizations using Tableau,
                Quicksight and Looker.
              </li>
              <li>
                Strong analytical and problem-solving skills with experience in
                providing dynamic and data-driven solutions.
              </li>
              <li>
                Extensive experience in building and maintaining Big Data,
                Business Intelligence and data warehouse products and services.
              </li>
            </ul>

            {/* <Typography sx={{ color: "customTextColor" }}>
              <b>Mandatory Skills</b>
            </Typography> */}
          </span>
        </Box>
        <div style={{ backgroundColor: "#fff", padding: "5px 10px 5px 10px" }}>
          <Box className={styles.recruiter_profile}>
            <div>
              <img src={profile_image} alt="" />
              <span style={{ color: customTextColor }}>
                <Typography>
                  <b>Ajit Kumar Gahan </b>
                </Typography>
                <Typography sx={{ marginTop: "10px !important" }}>
                  Senior IT Recruiter – Mind Blowing Solutions Inc
                </Typography>
                <Typography>
                  Ph: 1+ 424 550 7012 | E-Mail: ajit@mindblowingsolutions.com
                </Typography>
              </span>
            </div>
          </Box>
        </div>
      </Box>
      <Box className={styles.requiter_profile_section}>
        {/* {
              row?.shortlisted_candidates?.length !== 0 ?
                row?.shortlisted_candidates?.map((candidate) => {
                  return ( */}
        <JobPost
          // image={profile_image}
          date=" 17 May 2024, 10:30 PM"
          name="Srikant Mithar Reddy - H1B"
          skill="Java Developer - Dallas Taxes, TX "
          rate="$120 Hourly "
          btn1="View & Hide "
          btn2="Accepted "
        />
        <JobPost
          // image={profile_image}
          date=" 17 May 2024, 10:30 PM"
          name="Himanshu Mishra"
          skill=" Full Stack Java Developer - Dallas Taxes, TX "
          rate="$110 Hourly "
          btn1="Hidden "
          btn2="Waiting"
        />

        {/* )
                })
                :
                <p style={{ color: customTextColor, textAlign: 'center', padding: '20px', backgroundColor: '#fff' }}>No Respond Found</p>
            } */}
        <Box className={styles.send_update_btns}>
          <button
            onClick={() => navigate("/requirement-candidate-apply")}
            style={{ marginLeft: "15px", backgroundColor: "#4285f4" }}
          >
            Apply Now
          </button>
          {/* <Box>
            <span className={styles.new_update_btns}>
              <button style={{ backgroundColor: "#3856a6", marginRight: "0" }}>
                Ask More
              </button>
            </span>
          </Box> */}
        </Box>
      </Box>
      {/* <Box className={styles.internal_update_btns}>
        <Box className={styles.back_btns}>
          <button
            style={{
              backgroundColor: "#3856a6",
              padding: "7.5px 20px ",
            }}
            onClick={() => navigate("/more-view-apply")}
          >
            Apply
          </button>
          <span className={styles.add_btns}>
            <button
              style={{
                backgroundColor: "#4285f4",
                padding: "7.5px 10px ",
                marginLeft: "10px",
              }}
              onClick={() => navigate("/more-view-ask")}
            >
              Ask More
            </button>
          </span>
        </Box>
        <Box>
          <button
            style={{
              backgroundColor: "#f2f2f2 ",
              padding: "7.5px 10px ",
              border: "1.5px solid #beb5b5",
              color: "black",
            }}
          >
            Skip & Next
          </button>
        </Box>
      </Box> */}
    </>
    // </RootComponents>
  );
};

export default MoreViewDetails;
